import { observer, useTranslation, useLocation } from "../vendor/api.js";
// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import { interopDefault } from "../vendor/runtime.js";
import { module9103 as P } from "../vendor/dependencies.js";
import * as SiteState from "../state/siteStore.js";
import * as ReactDOM from "react-dom";
var getClassNames = interopDefault(P);
var rateLimitStyles = {
  mask: "rate-limit-popup_mask__V_gRY",
  dialog: "rate-limit-popup_dialog__V_gRY",
  dialogTokenPlan: "rate-limit-popup_dialogTokenPlan__V_gRY",
  maskTokenPlan: "rate-limit-popup_maskTokenPlan__V_gRY",
  closeBtn: "rate-limit-popup_closeBtn__V_gRY",
  contentWrapper: "rate-limit-popup_contentWrapper__V_gRY",
  contentWrapperTokenPlan: "rate-limit-popup_contentWrapperTokenPlan__V_gRY",
  iconWrapper: "rate-limit-popup_iconWrapper__V_gRY",
  tokenPlanIcon: "rate-limit-popup_tokenPlanIcon__V_gRY",
  tipText: "rate-limit-popup_tipText__V_gRY",
  tipMobileZh: "rate-limit-popup_tipMobileZh__V_gRY",
  tipTextTokenPlan: "rate-limit-popup_tipTextTokenPlan__V_gRY",
};
var rateLimitIcon =
  "/" + "static/token-plan-rate-limit-icon.9dbbcaf6ad729b2b.svg";
let rateLimitClassNames = getClassNames().bind(rateLimitStyles);
let RateLimitArtwork = () => (
  <svg
    width={"110"}
    height={"110"}
    viewBox={"0 0 110 110"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <g clipPath={"url(#clip0_7280_9632)"}>
      <rect width={"110"} height={"110"} fill={"white"} />
      <path
        d={
          "M55 99C63.7024 99 72.2093 96.4196 79.445 91.5848C86.6808 86.75 92.3204 79.8781 95.6507 71.8381C98.9809 63.7982 99.8523 54.9513 98.1545 46.4161C96.4568 37.8809 92.2662 30.0409 86.1127 23.8874C79.9592 17.7338 72.1191 13.5432 63.5839 11.8455C55.0488 10.1477 46.2019 11.0191 38.1619 14.3494C30.122 17.6796 23.2501 23.3192 18.4153 30.5549C13.5805 37.7907 11 46.2977 11 55.0001C11 66.6696 15.6357 77.8612 23.8873 86.1128C32.1389 94.3644 43.3305 99 55 99Z"
        }
        fill={"url(#paint0_linear_7280_9632)"}
        fillOpacity={"0.2"}
      />
      <mask
        id={"mask0_7280_9632"}
        maskUnits={"userSpaceOnUse"}
        x={"7"}
        y={"-1"}
        width={"97"}
        height={"97"}
      >
        <path
          d={
            "M55.0005 95.0008C64.4941 95.0008 73.7745 92.1858 81.6681 86.9114C89.5617 81.6371 95.7141 74.1404 99.3471 65.3695C102.98 56.5985 103.931 46.9473 102.079 37.6361C100.227 28.3249 95.6549 19.772 88.9419 13.0591C82.2289 6.34607 73.6761 1.77443 64.3649 -0.0776753C55.0537 -1.92978 45.4024 -0.979167 36.6315 2.65387C27.8606 6.28692 20.3639 12.4392 15.0895 20.3328C9.81517 28.2265 7 37.5069 7 47.0005C7 59.731 12.0572 71.9401 21.059 80.942C30.0608 89.9438 42.27 95.0008 55.0005 95.0008Z"
          }
          fill={"url(#paint1_linear_7280_9632)"}
          fillOpacity={"0.2"}
        />
      </mask>
      <g mask={"url(#mask0_7280_9632)"}>
        <path
          d={
            "M94.1041 82.0473C59.7974 69.9433 29.669 75.7386 13.7001 82.3179C11.8086 83.0973 12.4125 85.56 14.4583 85.56H93.441C95.6075 85.56 96.1472 82.7682 94.1041 82.0473Z"
          }
          fill={"url(#paint2_linear_7280_9632)"}
        />
        <path
          d={
            "M19.3772 70.4576C19.7255 70.208 20.194 70.208 20.5423 70.4576L29.4853 76.8671C30.2753 77.4333 29.8747 78.6799 28.9027 78.6799H11.0168C10.0448 78.6799 9.6442 77.4333 10.4343 76.8671L19.3772 70.4576Z"
          }
          fill={"url(#paint3_linear_7280_9632)"}
        />
        <path
          d={
            "M107.182 78.3191C92.1058 65.6996 78.8665 71.8407 72.0208 78.5702C70.848 79.7231 71.7365 81.5598 73.3811 81.5598H105.91C107.683 81.5598 108.542 79.4573 107.182 78.3191Z"
          }
          fill={"url(#paint4_linear_7280_9632)"}
        />
      </g>
      <path
        d={
          "M20.3172 86H11.1124C10.2684 86 9.80397 85.0189 10.3389 84.3662L21.826 70.349C22.1322 69.9753 22.6619 69.874 23.0845 70.1084L28.3544 73.0314C28.7534 73.2527 29.2516 73.1759 29.5654 72.8447L46.9129 54.5355C47.7552 53.6464 49.1506 54.76 48.4704 55.7786L31.6915 80.9064C31.4368 81.288 30.9551 81.4472 30.5231 81.2927L25.8018 79.6042C25.3595 79.446 24.8667 79.6171 24.6175 80.0152L21.1648 85.5306C20.982 85.8226 20.6617 86 20.3172 86Z"
        }
        fill={"url(#paint5_linear_7280_9632)"}
      />
      <path
        d={
          "M69.2742 39H62.9364C62.1243 39 61.6509 38.0832 62.121 37.4211L71.6121 24.0534C71.8882 23.6646 72.4004 23.5248 72.8357 23.7194L78.1086 26.0771C78.4881 26.2467 78.933 26.164 79.226 25.8691L89.3718 15.6622C90.2013 14.8276 91.5403 15.862 90.9422 16.8755L81.4105 33.0257C81.1519 33.4638 80.6056 33.638 80.1411 33.4303L75.1501 31.1987C74.6729 30.9853 74.1119 31.1754 73.8628 31.6349L70.1533 38.4766C69.9785 38.7991 69.6411 39 69.2742 39Z"
        }
        fill={"url(#paint6_linear_7280_9632)"}
      />
      <circle cx={"99"} cy={"18"} r={"3"} fill={"#E8F4FF"} />
      <g filter={"url(#filter0_i_7280_9632)"}>
        <path
          d={
            "M5 52.2684C5.27849 47.0971 6.34275 42.1347 8.07549 37.4983C8.92003 37.1763 9.83646 37 10.7941 37C14.7008 37 17.9221 39.935 18.3732 43.7204C18.6002 43.6833 18.8332 43.6641 19.0707 43.6641C21.4457 43.6641 23.371 45.5894 23.371 47.9644C23.371 50.3394 21.4457 52.2647 19.0707 52.2647C18.9993 52.2647 18.9283 52.263 18.8577 52.2595V52.2684H5Z"
          }
          fill={"white"}
          fillOpacity={"0.6"}
        />
      </g>
      <ellipse
        cx={"27.5"}
        cy={"54"}
        rx={"3.5"}
        ry={"8"}
        fill={"url(#paint7_linear_7280_9632)"}
      />
      <ellipse
        cx={"81.5"}
        cy={"54"}
        rx={"3.5"}
        ry={"8"}
        fill={"url(#paint8_linear_7280_9632)"}
      />
      <ellipse
        cx={"54.5"}
        cy={"54"}
        rx={"27.5"}
        ry={"23"}
        fill={"url(#paint9_linear_7280_9632)"}
      />
      <rect
        x={"35"}
        y={"39"}
        width={"39"}
        height={"30"}
        rx={"4"}
        fill={"url(#paint10_linear_7280_9632)"}
      />
      <rect
        x={"49.3628"}
        y={"48.4395"}
        width={"2.3315"}
        height={"6.9945"}
        rx={"1.16575"}
        transform={"rotate(45 49.3628 48.4395)"}
        fill={"#BAD2FF"}
      />
      <rect
        x={"64.3179"}
        y={"48.4395"}
        width={"2.3315"}
        height={"6.9945"}
        rx={"1.16575"}
        transform={"rotate(45 64.3179 48.4395)"}
        fill={"#BAD2FF"}
      />
      <rect
        x={"51.0117"}
        y={"53.3857"}
        width={"2.3315"}
        height={"6.9945"}
        rx={"1.16575"}
        transform={"rotate(135 51.0117 53.3857)"}
        fill={"#BAD2FF"}
      />
      <rect
        x={"65.9668"}
        y={"53.3857"}
        width={"2.3315"}
        height={"6.9945"}
        rx={"1.16575"}
        transform={"rotate(135 65.9668 53.3857)"}
        fill={"#BAD2FF"}
      />
      <path
        d={"M60 60C58.4941 58.4908 54.1624 56.3778 51 60"}
        stroke={"#BAD2FF"}
        strokeWidth={"2"}
        strokeLinecap={"round"}
      />
      <path
        d={
          "M93.4204 9.6802C94.0568 9.46806 94.7174 9.93026 94.7363 10.6008L94.9455 18.0457C94.9686 18.8671 94.046 19.3642 93.3726 18.8931L86.0978 13.8036C85.4245 13.3325 85.5752 12.2954 86.3548 12.0355L93.4204 9.6802Z"
        }
        fill={"url(#paint11_linear_7280_9632)"}
      />
    </g>
    <defs>
      <filter
        id={"filter0_i_7280_9632"}
        x={"5"}
        y={"37"}
        width={"19.3711"}
        height={"16.2686"}
        filterUnits={"userSpaceOnUse"}
        colorInterpolationFilters={"sRGB"}
      >
        <feFlood floodOpacity={"0"} result={"BackgroundImageFix"} />
        <feBlend
          mode={"normal"}
          in={"SourceGraphic"}
          in2={"BackgroundImageFix"}
          result={"shape"}
        />
        <feColorMatrix
          in={"SourceAlpha"}
          type={"matrix"}
          values={"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"}
          result={"hardAlpha"}
        />
        <feOffset dx={"1"} dy={"1"} />
        <feGaussianBlur stdDeviation={"2.5"} />
        <feComposite
          in2={"hardAlpha"}
          operator={"arithmetic"}
          k2={"-1"}
          k3={"1"}
        />
        <feColorMatrix
          type={"matrix"}
          values={"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"}
        />
        <feBlend
          mode={"normal"}
          in2={"shape"}
          result={"effect1_innerShadow_7280_9632"}
        />
      </filter>
      <linearGradient
        id={"paint0_linear_7280_9632"}
        x1={"30.3457"}
        y1={"21.1609"}
        x2={"86.2071"}
        y2={"73.8526"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#97DCFC"} />
        <stop offset={"1"} stopColor={"#7AA2FF"} />
      </linearGradient>
      <linearGradient
        id={"paint1_linear_7280_9632"}
        x1={"28.1046"}
        y1={"10.0848"}
        x2={"89.0449"}
        y2={"67.5672"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#97DCFC"} />
        <stop offset={"1"} stopColor={"#7AA2FF"} />
      </linearGradient>
      <linearGradient
        id={"paint2_linear_7280_9632"}
        x1={"55"}
        y1={"85.56"}
        x2={"55"}
        y2={"75"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#EAEAEA"} stopOpacity={"0.07"} />
        <stop offset={"1"} stopColor={"#2465FF"} />
      </linearGradient>
      <linearGradient
        id={"paint3_linear_7280_9632"}
        x1={"19.9598"}
        y1={"70.04"}
        x2={"20.4572"}
        y2={"77.7059"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#0F62FE"} />
        <stop offset={"1"} stopColor={"#F2F2F2"} stopOpacity={"0"} />
      </linearGradient>
      <linearGradient
        id={"paint4_linear_7280_9632"}
        x1={"90.5195"}
        y1={"79.1598"}
        x2={"90.0395"}
        y2={"71"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#EAEAEA"} stopOpacity={"0"} />
        <stop offset={"1"} stopColor={"#93B8FF"} />
      </linearGradient>
      <linearGradient
        id={"paint5_linear_7280_9632"}
        x1={"18.8843"}
        y1={"49.5565"}
        x2={"48.0581"}
        y2={"59.0779"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#7DC1FF"} />
        <stop offset={"1"} stopColor={"#5083FB"} />
      </linearGradient>
      <linearGradient
        id={"paint6_linear_7280_9632"}
        x1={"68.3058"}
        y1={"12.5785"}
        x2={"89.7876"}
        y2={"19.7261"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#7DC1FF"} />
        <stop offset={"1"} stopColor={"#5083FB"} />
      </linearGradient>
      <linearGradient
        id={"paint7_linear_7280_9632"}
        x1={"25.5041"}
        y1={"47.4226"}
        x2={"30.3419"}
        y2={"48.0233"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#7DC1FF"} />
        <stop offset={"1"} stopColor={"#5083FB"} />
      </linearGradient>
      <linearGradient
        id={"paint8_linear_7280_9632"}
        x1={"79.5041"}
        y1={"47.4226"}
        x2={"84.3419"}
        y2={"48.0233"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#7DC1FF"} />
        <stop offset={"1"} stopColor={"#5083FB"} />
      </linearGradient>
      <linearGradient
        id={"paint9_linear_7280_9632"}
        x1={"45.9063"}
        y1={"33.875"}
        x2={"67.6663"}
        y2={"73.5657"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#ADCEFF"} />
        <stop offset={"1"} stopColor={"#DFE8FF"} />
      </linearGradient>
      <linearGradient
        id={"paint10_linear_7280_9632"}
        x1={"74"}
        y1={"40.9565"}
        x2={"36.7651"}
        y2={"69.3576"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#F8FCFF"} />
        <stop offset={"0.754799"} stopColor={"#E8F2FE"} />
        <stop offset={"0.988581"} stopColor={"#D3E4FF"} />
      </linearGradient>
      <linearGradient
        id={"paint11_linear_7280_9632"}
        x1={"90.6425"}
        y1={"7.66925"}
        x2={"96.2516"}
        y2={"15.6868"}
        gradientUnits={"userSpaceOnUse"}
      >
        <stop stopColor={"#7DC1FF"} />
        <stop offset={"1"} stopColor={"#5083FB"} />
      </linearGradient>
      <clipPath id={"clip0_7280_9632"}>
        <rect width={"110"} height={"110"} fill={"white"} />
      </clipPath>
    </defs>
  </svg>
);
let RateLimitPopup = observer(() => {
  let { t: translate, i18n: i18n } = useTranslation(),
    { language: language } = i18n,
    { showRateLimitPopup: showRateLimitPopup } = SiteState.siteStore,
    { pathname: pathname } = useLocation(),
    l = pathname.includes("/token-plan");
  if (!showRateLimitPopup) return null;
  let s = (
    <div
      className={rateLimitClassNames("mask", {
        maskTokenPlan: l,
      })}
      onClick={(e) => {
        e.stopPropagation();
      }}
      role={"presentation"}
    >
      <div
        className={rateLimitClassNames("dialog", {
          dialogTokenPlan: l,
        })}
        onClick={(e) => e.stopPropagation()}
        role={"dialog"}
        aria-modal={true}
        aria-labelledby={"rate-limit-title"}
      >
        <div
          className={rateLimitClassNames("contentWrapper", {
            contentWrapperTokenPlan: l,
          })}
        >
          <div className={rateLimitStyles.iconWrapper}>
            {l ? (
              <img
                className={rateLimitStyles.tokenPlanIcon}
                src={rateLimitIcon}
                alt={""}
                width={110}
                height={110}
              />
            ) : (
              <RateLimitArtwork />
            )}
          </div>
          <p
            id={"rate-limit-title"}
            className={rateLimitClassNames("tipText", {
              tipMobileZh: "zh" === language,
              tipTextTokenPlan: l,
            })}
          >
            {translate("common.rateLimitTip")}
          </p>
        </div>
      </div>
    </div>
  );
  return (0, ReactDOM.createPortal)(s, document.body);
});
export {
  getClassNames,
  rateLimitStyles,
  rateLimitIcon,
  rateLimitClassNames,
  RateLimitArtwork,
  RateLimitPopup,
};
